module.exports = __webpack_public_path__ + "static/img/banner04.a07e2524.png";